import { render, staticRenderFns } from "./RiwayatAdmin.vue?vue&type=template&id=198551ce&scoped=true"
import script from "./RiwayatAdmin.vue?vue&type=script&lang=js"
export * from "./RiwayatAdmin.vue?vue&type=script&lang=js"
import style0 from "./RiwayatAdmin.vue?vue&type=style&index=0&id=198551ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198551ce",
  null
  
)

export default component.exports